"use client"

import styled from "@emotion/styled"
import { Button, Typography } from "@mui/material"
import { useTranslations } from "next-intl"
import Image from "next/image"
import { Desktop, Mobile } from "ui"
import { Link } from "utils"
const StyledLayout = styled.div`
  height: 552px;
  width: 100%;
  position: relative;
  margin-bottom: 48px;
  display: flex;
  padding-top: 120px;
  justify-content: center;
  ${({ theme }) => theme.breakpoints.up("md")} {
    padding-top: 267px;
    margin-bottom: 64px;
    height: 780px;
  }
`

const StyledBox = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: center;

  gap: 32px;
  z-index: 1;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 48px;
  }
`

const TextBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  ${({ theme }) => theme.breakpoints.up("md")} {
    gap: 24px;
  }
`

const StyledButton = styled(Button)`
  width: 100%;
  ${({ theme }) => theme.breakpoints.up("md")} {
    width: 300px;
  }
`

export default function NotFound() {
  const tInner = useTranslations("InnerPages")
  return (
    <StyledLayout>
      <StyledBox>
        <TextBox>
          <Desktop>
            <Typography variant="h1">{tInner("pageNotFound")}</Typography>
          </Desktop>
          <Mobile>
            <Typography variant="h3">{tInner("pageNotFound")}</Typography>
          </Mobile>
          <Typography variant="body1">{tInner("wrongStop")}</Typography>
        </TextBox>
        <StyledButton href="/" variant="primary" LinkComponent={Link}>
          {tInner("backToHomepage")}
        </StyledButton>
      </StyledBox>
      <Image
        src={"/images/404.png"}
        alt="404"
        fill
        style={{ objectFit: "contain" }}
      />
    </StyledLayout>
  )
}
